export default "__VITE_ASSET__COnlBgu9__"